import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { NzModalService, TransferItem } from 'ng-zorro-antd';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { $e } from 'codelyzer/angular/styles/chars';
import {
  DistributorsService,
  ProductsDistributorsService,
  RootService,
} from '../../../../../services';
import { UploaderComponent } from '../../../../../shared/uploader';
import { DocumentsService } from '../../../../../services/business/documents/documents.service';
import {DomSanitizer} from '@angular/platform-browser';
import {HandleVideo} from '../../../../../shared/common/handle-video';

@Component({
  selector: 'add-product-distributors',
  templateUrl: './add-product-distributors.component.html',
  styleUrls: ['./add-product-distributors.component.scss'],
})
export class AddProductDistributorsComponent extends HandleVideo implements OnInit, OnDestroy {
  isVisible = false;
  actions = [
    { label: 'Gán sản phẩm', value: 0 },
    { label: 'Gỡ sản phẩm', value: 1 },
    { label: 'Export', value: 2 },
    { label: 'Export tất cả', value: 3 },
  ];
  current = 0;
  index = 1;
  title;
  list: TransferItem[] = [];
  searchPlaceholder = 'Tên hoặc mã sản phẩm';
  itemsUnit = 'Sản phẩm';
  pageIndex = 1;
  pageSize = 5;
  changeTabEvent = 1;
  city = null;
  cityNew = null;
  districts = null;
  street = null;
  unsubscribe$ = new Subject<void>();
  avatar: any[] = [];
  background: any[] = [];
  introImage: any[] = [];
  nameDistributor = '';
  taxCode = ''
  address = ''
  phoneNumber = ''
  email = ''
  website = ''
  public config = {
    placeholder: '',
    tabsize: 2,
    height: '250px',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      // ["insert", ["link", "video"]],
      ['insert', ['link']],
    ],
    fontNames: [
      'Helvetica',
      'Arial',
      'Arial Black',
      'Comic Sans MS',
      'Courier New',
      'Roboto',
      'Times',
    ],
    disableDragAndDrop: true

  };

  // tslint:disable-next-line:variable-name
  form_step: FormGroup = this.fb.group({
    id: [null, [Validators.required]],
    title: [null, [Validators.required]],
    role: [null, [Validators.required]],
  });
  isLoadingBtn = false;
  // tslint:disable-next-line:variable-name
  notDocuments = false;
  files: any[] = [];
  listTitle;
  listRole;

  // @ts-ignore
  @ViewChild('selectDocument') selectDocument;
  // @ts-ignore
  @ViewChild('create') create;
  @Output() loadDataParent = new EventEmitter();
  @Input() productId: string;
  optionList: any;
  isLoading = false;
  searchChange$ = new BehaviorSubject('');
  viewDetail;
  countries: any;
  listWard: any = [];
  // tslint:disable-next-line:variable-name
  country_code: any;
  constructor(
    public fb: FormBuilder,
    public modalService: NzModalService,
    public notification: NzNotificationService,
    public distributorsService: DistributorsService,
    public rootService: RootService,
    public productsDistributorsService: ProductsDistributorsService,
    public docService: DocumentsService,
    public sanitizer: DomSanitizer,
    public modal: NzModalService,
  ) {
    super(modalService, fb, sanitizer, modal, notification, rootService);
    const optionList$: Observable<string> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500));

    optionList$.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      if (value && value.trim().length > 0) {
        const query = {
          product_id: this.productId,
          name: value.trim(),
        };
        this.productsDistributorsService
          .searchDistributor(query)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((res) => {
            this.optionList = res.data;
            this.isLoading = false;
          });
      } else {
        this.optionList = [];
        this.isLoading = false;
      }
    });
  }

  ngOnInit() {

    this.notification.config({
      nzPlacement: 'bottomRight',
    });

    this.distributorsService
      .listRole()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.listRole = res.data;
      });

    // this.distributorsService.listTitle({roleCode: data.roleCode}).subscribe((res) => {
    //   this.listTitle = res.data;
    // });
    this.form_step1.get('provinceNewId').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      if (val) {
        this.rootService.getLocationNew({
          type: 2,
          parentId: val
        }).subscribe((res: any) => {
          if (res.code === 1) {
            this.listWard = res && res.data && res.data.data ?  res.data.data : [];
          }
        });
      }
    });
  }

  roleChange($event: any) {
    this.listTitle = null;
    this.form_step.get('title').setValue(null);
    if ($event) {
      this.distributorsService
        .listTitle({ roleCode: $event })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          this.listTitle = res.data;
        });
    }
  }

  onSearch(value: string): void {
    this.isLoading = true;
    this.searchChange$.next(value);
  }

  selectId($id) {
    if ($id) {
      this.distributorsService
        .detailDistributor($id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          this.viewDetail = res.data;
        });
    }
  }

  select(ret: {}): void {
    // console.log('nzSelectChange', ret);
  }

  change(ret: {}): void {
    // console.log('nzChange', ret);
  }

  handleCancel(): void {
    this.isVisible = false;
    this.avatar = [];
    this.background = [];
    this.viewDetail = null;
    this.files = [];
    this.notDocuments = false;
    this.form_step.reset();
    this.form_step1.reset();
  }

  showModal(): void {
    this.isVisible = true;
    this.changeTabEvent = 1;
    this.rootService
      .listCities()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.city = res.data.items;
      });
    this.getCities();
    this.rootService.listCities().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.city = res.data.items;
      // console.log("this.city", this.city)
    });

    this.rootService.getLocationNew({
      type: 1
    }).subscribe((res) => {
      this.cityNew = res.data.data;
      // console.log("this.city2", this.city)
    });
  }


  changeTab(event) {
    this.introImage = [];
    this.introVideo = [];
    this.changeTabEvent = event;
    if (this.changeTabEvent === 1) {
      this.notDocuments = false;
      this.files = [];
      this.form_step.reset();
    } else {
      this.notDocuments = false;
      this.files = [];
      this.viewDetail = null;
      this.form_step1.reset();
      this.form_step1.get('addressNew').setValue(true);
    }
  }
  getCities() {
    this.rootService
      .listCountries()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res.code === 1) {
          this.countries = res.data.items;
        }
      });
  }
  citiChange(event) {
    if (event) {
      // this.country_id = event.split('-')[0];
      this.country_code = event.split('-')[1];

      if (this.country_code !== 'VN') {
        this.form_step1.controls.province_id.clearValidators();
        this.form_step1.controls.province_id.disable();
        this.form_step1.controls.district_id.clearValidators();
        this.form_step1.controls.district_id.disable();
        this.form_step1.controls.streetId.clearValidators();
        this.form_step1.controls.streetId.disable();
        this.form_step1.controls.provinceNewId.clearValidators();
        this.form_step1.controls.provinceNewId.disable();
        this.form_step1.controls.wardNewId.clearValidators();
        this.form_step1.controls.wardNewId.disable();
        this.form_step1.controls.province_id.setValue(null);
        this.form_step1.controls.district_id.setValue(null);
        this.form_step1.controls.streetId.setValue(null);
        this.form_step1.controls.provinceNewId.setValue(null);
        this.form_step1.controls.wardNewId.setValue(null);

        return;
      }
      this.form_step1.controls.province_id.setValidators(Validators.required);
      this.form_step1.controls.province_id.enable();
      this.form_step1.controls.district_id.setValidators(Validators.required);
      this.form_step1.controls.district_id.enable();
      this.form_step1.controls.streetId.setValidators(Validators.required);
      this.form_step1.controls.streetId.enable();

      this.form_step1.controls.provinceNewId.setValidators(Validators.required);
      this.form_step1.controls.provinceNewId.enable();
      this.form_step1.controls.wardNewId.setValidators(Validators.required);
      this.form_step1.controls.wardNewId.enable();
    }else {
      this.form_step1.controls.province_id.clearValidators();
      this.form_step1.controls.province_id.disable();
      this.form_step1.controls.district_id.clearValidators();
      this.form_step1.controls.district_id.disable();
      this.form_step1.controls.streetId.clearValidators();
      this.form_step1.controls.streetId.disable();
      this.form_step1.controls.provinceNewId.clearValidators();
      this.form_step1.controls.provinceNewId.disable();
      this.form_step1.controls.wardNewId.clearValidators();
      this.form_step1.controls.wardNewId.disable();

      this.form_step1.controls.province_id.setValue(null);
      this.form_step1.controls.district_id.setValue(null);
      this.form_step1.controls.streetId.setValue(null);
      this.form_step1.controls.provinceNewId.setValue(null);
      this.form_step1.controls.wardNewId.setValue(null);
    }
  }
  onSubmit() {

    if (this.changeTabEvent === 1) {

      if (this.files.length === 0) {
        this.notDocuments = true;
        return;
      }

      // if (form.invalid) {
      //   return;
      // }

      const docs = [];
      this.files.map((item) => {
        docs.push(item.documentId);
      });

      const body = {
        titleId: this.form_step.get('title').value,
        documents: docs,
        assignProduct: [this.productId],
        businessId: this.form_step.get('id').value,
        roleCode: this.form_step.get('role').value,
      };

      this.isLoadingBtn = true;
      this.productsDistributorsService
        .addIdDistributor(body)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            if (res.code === 1) {
              this.notification.create(
                'success',
                'Thành công',
                'Tạo nhà phân phối thành công'
              );
              this.loadDataParent.emit(true);
              this.handleCancel();
              this.isVisible = false;
            } else {
              this.notification.create('warning', 'Cảnh báo', res.message);
            }
            this.isLoadingBtn = false;
          },
          (err) => {
            this.notification.create('error', 'Thất bại', err);
            this.isLoadingBtn = false;
          }
        );
    } else {
      const form = this.form_step1;


      if (this.files.length === 0) {
        this.notDocuments = true;
        return;
      }

      const docs = [];
      this.files.map((item) => {
        docs.push(item.documentId);
      });
      // tslint:disable-next-line:radix
      console.log(this.form_step1.value)
      const countryId$ = parseInt(
        this.form_step1.value.country_id.split('-')[0]
      );
      let intro = ''
      if(this.form_step1.get('intro').value){
        intro = this.form_step1.get('intro').value.trim()
      }
      const body = {
        name: this.form_step1.get('name').value,
        countryId: countryId$,
        address: this.form_step1.get('address').value,
        province_id:
          this.country_code !== 'VN'
            ? 0
            : this.form_step1.get('province_id').value,
        district_id:
          this.country_code !== 'VN'
            ? 0
            : this.form_step1.get('district_id').value,
        tax_code: this.form_step1.get('tax_code').value,
        streetId:
          this.country_code !== 'VN'
            ? 0
            : this.form_step1.get('streetId').value,
        email: this.form_step1.get('email').value,
        website: this.form_step1.get('website').value,
        phone: this.form_step1.get('phone').value,
        avatar: this.form_step1.get('avatar').value,
        background: this.form_step1.get('background').value,
        roleCode: this.form_step1.get('role').value,
        titleId: this.form_step1.get('title').value,
        addressNew: this.form_step1.get('addressNew').value,
        provinceNewId: this.form_step1.get('provinceNewId').value,
        wardNewId: this.form_step1.get('wardNewId').value,
        addressNewName: this.form_step1.get('addressNewName').value,
        intro,
        introImage: this.introImage.map(z => z.url),
        introVideo: this.introVideo,
        documents: docs
      };

      if (body.addressNew) {
        body.province_id = null;
        body.district_id = null;
        body.address = null;
      } else {
        body.provinceNewId = null;
        body.wardNewId = null;
        body.addressNewName = null;
      }

      this.isLoadingBtn = true;
      this.productsDistributorsService
        .addDistributor(this.productId, body)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            if (res.code === 1) {
              this.notification.create(
                'success',
                'Thành công',
                'Tạo nhà phân phối thành công'
              );
              this.loadDataParent.emit(true);
              this.handleCancel();
              this.isVisible = false;
            } else {
              this.notification.create('warning', 'Cảnh báo', res.message);
            }
            this.isLoadingBtn = false;
          },
          (err) => {
            this.notification.create('error', 'Thất bại', err);
            this.isLoadingBtn = false;
          }
        );
    }
  }
  getDistrictsNew($event: any) {
    this.form_step1.get('wardNewId').setValue(null);
  }
  getDistricts($event: any) {
    this.districts = null;
    this.street = null;
    this.form_step1.get('district_id').setValue(null);
    this.form_step1.get('streetId').setValue(null);
    if ($event !== null) {
      this.rootService
        .listDistricts($event)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          this.districts = res.data.items;
        });
    }
  }

  getStreet($event: any) {
    this.street = null;
    this.form_step1.get('streetId').setValue(null);
    if ($event !== null) {
      this.rootService
        .listWards($event)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          this.street = res.data.items;
        });
    }
  }

  /*document*/
  newDocument(event) {
    this.docService.create(event).subscribe(
      (res) => {
        if (res.code === 1) {
          this.create.hide();
          this.files.push(res.data);
          this.notDocuments = false;
          this.files.map((item) => {
            this.selectDocument.setId(item.documentId, true);
          });
          this.notification.create(
            'success',
            'Thêm giấy tờ thành công',
            res.message
          );
        } else {
          this.notification.create(
            'error',
            'Thêm giấy tờ thất bại',
            res.message
          );
        }
      },
      (err) => {
        this.notification.create('error', 'Thêm giấy tờ thất bại', err);
      }
    );
  }

  delete(file, index) {
    this.selectDocument.setId(this.files[index].documentId, false);
    this.files.splice(index, 1);
    if (!this.files.length) {
      this.notDocuments = true;
    }
  }

  modalDocument() {
    this.selectDocument.setCheckboxAll();
    this.files.map((res) => {
      this.selectDocument.setId(res.documentId, true);
    });
    this.selectDocument.showModal();
  }

  selectDocuments(event) {
    this.notDocuments = event.ids.length === 0;
    const newList = [];
    event.ids.map((item, key) => {
      const data = {
        documentId: item,
        title: event.titles[key],
      };
      newList.push(data);
    });
    this.files = newList;
    this.selectDocument.handleCancel();
  }

  /*End document*/
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
